import React, { useContext, useState } from 'react';
import { Outlet, useNavigate, useLocation } from 'react-router-dom';
import { Layout, Menu, Button, Typography, Avatar, Dropdown, Grid } from 'antd';
import {
    DashboardOutlined,
    FileProtectOutlined,
    AlertOutlined,
    DollarOutlined,
    UserOutlined,
    LogoutOutlined,
    MenuOutlined,
    HomeOutlined,
} from '@ant-design/icons';
import { ClientAuthContext } from '../../common/constants';
import logo from '../../assets/logo/logo-cap-assurances.JPG';
import './ClientLayout.scss';

const { Header, Sider, Content } = Layout;
const { Text } = Typography;
const { useBreakpoint } = Grid;

const menuItems = [
    { key: '/espace-client', icon: <DashboardOutlined />, label: 'Tableau de bord' },
    { key: '/espace-client/contrats', icon: <FileProtectOutlined />, label: 'Mes contrats' },
    { key: '/espace-client/sinistres', icon: <AlertOutlined />, label: 'Mes sinistres' },
    { key: '/espace-client/situation', icon: <DollarOutlined />, label: 'Situation financiere' },
    { key: '/espace-client/profil', icon: <UserOutlined />, label: 'Mon profil' },
];

export default function ClientLayout() {
    const navigate = useNavigate();
    const location = useLocation();
    const auth = useContext(ClientAuthContext);
    const screens = useBreakpoint();
    const [collapsed, setCollapsed] = useState(false);

    const isMobile = !screens.lg;
    const client = auth.currentClient;

    const clientNom = client?.type === 'entreprise'
        ? client?.nom
        : `${client?.prenom || ''} ${client?.nom || ''}`.trim();

    const handleMenuClick = ({ key }) => {
        navigate(key);
    };

    const handleLogout = () => {
        auth.onLogout();
        navigate('/');
    };

    const userMenuItems = [
        { key: 'profil', icon: <UserOutlined />, label: 'Mon profil', onClick: () => navigate('/espace-client/profil') },
        { key: 'site', icon: <HomeOutlined />, label: 'Retour au site', onClick: () => navigate('/') },
        { type: 'divider' },
        { key: 'logout', icon: <LogoutOutlined />, label: 'Deconnexion', danger: true, onClick: handleLogout },
    ];

    const selectedKey = menuItems.find(
        item => location.pathname === item.key || (item.key !== '/espace-client' && location.pathname.startsWith(item.key))
    )?.key || '/espace-client';

    return (
        <Layout className="client-layout" style={{ minHeight: '100vh' }}>
            {!isMobile && (
                <Sider
                    width={250}
                    collapsible
                    collapsed={collapsed}
                    onCollapse={setCollapsed}
                    theme="light"
                    className="client-sider"
                >
                    <div className="sider-logo" onClick={() => navigate('/')}>
                        <img src={logo} alt="CAP Assurances" />
                        {!collapsed && <span className="sider-logo-text">Espace Client</span>}
                    </div>
                    <Menu
                        mode="inline"
                        selectedKeys={[selectedKey]}
                        items={menuItems}
                        onClick={handleMenuClick}
                        style={{ border: 'none' }}
                    />
                </Sider>
            )}

            <Layout>
                <Header className="client-header">
                    {isMobile && (
                        <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                            <Button type="text" icon={<MenuOutlined />} onClick={() => setCollapsed(!collapsed)} />
                            <img src={logo} alt="CAP" style={{ height: 32 }} onClick={() => navigate('/')} />
                        </div>
                    )}
                    <div style={{ flex: 1 }} />
                    <Dropdown menu={{ items: userMenuItems }} placement="bottomRight">
                        <div className="user-menu-trigger">
                            <Avatar icon={<UserOutlined />} style={{ background: '#1A2B5F' }} size="small" />
                            {!isMobile && <Text strong style={{ marginLeft: 8 }}>{clientNom}</Text>}
                        </div>
                    </Dropdown>
                </Header>

                <Content className="client-content">
                    <Outlet />
                </Content>
            </Layout>

            {/* Drawer mobile */}
            {isMobile && collapsed && (
                <div className="mobile-overlay" onClick={() => setCollapsed(false)}>
                    <div className="mobile-drawer" onClick={(e) => e.stopPropagation()}>
                        <div className="sider-logo" onClick={() => { navigate('/'); setCollapsed(false); }}>
                            <img src={logo} alt="CAP Assurances" />
                            <span className="sider-logo-text">Espace Client</span>
                        </div>
                        <Menu
                            mode="inline"
                            selectedKeys={[selectedKey]}
                            items={menuItems}
                            onClick={(info) => { handleMenuClick(info); setCollapsed(false); }}
                            style={{ border: 'none' }}
                        />
                        <div style={{ padding: 16 }}>
                            <Button block danger icon={<LogoutOutlined />} onClick={handleLogout}>
                                Deconnexion
                            </Button>
                        </div>
                    </div>
                </div>
            )}
        </Layout>
    );
}
